export default {
  methods: {
    closeAlert () {
      this.$store.commit('setShowAlert', false)
    },
    alertFailed (message = 'Terjadi Kesalahan') {
      this.$store.commit('setAlertType', 'failed')
      this.$store.commit('setAlertMessage', message)
      this.$store.commit('setShowAlert', true)
    },
    alertConfirmation (message = 'Apakah anda yakin ingin melanjutkan ?', callback) {
      this.$store.commit('setAlertType', 'confirmation')
      this.$store.commit('setAlertMessage', message)
      this.$store.commit('setAlertCallback', callback)
      this.$store.commit('setShowAlert', true)
    },
    alertNormal (message = 'Berhasil') {
      this.$store.commit('setAlertType', 'normal')
      this.$store.commit('setAlertMessage', message)
      this.$store.commit('setShowAlert', true)
    },
    toast ({ type = 'failed', message = 'Terjadi kesalahan' }) {
      this.$store.commit('setAlertType', type)
      this.$store.commit('setAlertMessage', message)
      this.$store.commit('setShowAlert', true)
    }
  }
}
